






















import Component from 'vue-class-component';
import Vue from 'vue';
import ClientOnly from 'vue-client-only';
import VueZoomer from 'vue-zoomer';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import IImage from '@frontend/types/base/IImage';
import { MountingPortal } from 'portal-vue';
import { Prop } from 'vue-property-decorator';

Vue.use(VueZoomer);

@Component({
	hydration: true,
	components: {
		ClientOnly,
		ButtonComponent,
		MountingPortal
	},
	componentId: 'C049'
})
export default class ImageZoom extends Vue {
	@Prop(Object)
	protected readonly image!: IImage;

	@Prop(String)
	protected readonly wrapperClassName?: string;

	protected portalMounted = false;

	protected imageVisible = false;

	protected mounted(): void {
		this.initMqManager();
	}

	protected get aspectRatio(): number {
		if (this.image.aspectRatio) {
			const parts = this.image.aspectRatio.split('x');
			return Number(parts[0]) / Number(parts[1]);
		}
		if (this.image.width && this.image.height) {
			return this.image.width / this.image.height;
		}
		return 16 / 9;
	}

	protected get imageSrc(): string {
		if (this.image.srcset) {
			return this.image.srcset[this.image.srcset.length - 1].src;
		}

		return this.image.src as string;
	}

	protected zoomInClick(): void {
		(this.$refs.zoomer as any).zoomIn(2);
	}

	protected zoomOutClick(): void {
		(this.$refs.zoomer as any).zoomIn(0.5);
	}

	protected openZoom(): void {
		this.portalMounted = true;
		setTimeout(() => {
			this.imageVisible = true;
		}, 10);
	}

	protected closeZoom(): void {
		this.imageVisible = false;
		setTimeout(() => {
			this.portalMounted = false;
		}, 500);
	}

	private initMqManager(): void {
		const mqXLarge = window.matchMedia('(min-width: 981px)');

		const checkMql = (): void => {
			this.closeZoom();
		};

		if (mqXLarge.addEventListener) {
			mqXLarge.addEventListener('change', checkMql);
		} else {
			// Safari only supports the old syntax
			mqXLarge.addListener(checkMql);
		}
	}
}
